module.exports = __webpack_public_path__ + "img/qr_sample.6439108e.jpg";